import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import { KeyValue } from "./statement-key-value";
import { COLUMN } from "./statement-layout";
import {
  BLOCK_TYPE,
  type DividerBlock,
  type NoteBlock,
  type StatementBlock,
} from "./statement-schema";
import { Section } from "./statement-section";
import { Summary } from "./statement-summary";
import { Totals } from "./statement-totals";

const Note = ({ block }: { block: NoteBlock }) => (
  <p className="text-sm text-subtle">{block.text}</p>
);

const Divider = ({ block }: { block: DividerBlock }) => (
  <Text
    variant="caption"
    className="font-medium tracking-widest text-subtle uppercase"
  >
    {block.label}
  </Text>
);

const renderBlock = (block: StatementBlock, index: number) => {
  switch (block.type) {
    case BLOCK_TYPE.summary:
      return <Summary key={index} block={block} />;
    case BLOCK_TYPE.section:
      return <Section key={index} block={block} />;
    case BLOCK_TYPE.keyValue:
      return <KeyValue key={index} block={block} />;
    case BLOCK_TYPE.totals:
      return <Totals key={index} block={block} />;
    case BLOCK_TYPE.note:
      return <Note key={index} block={block} />;
    case BLOCK_TYPE.divider:
      return <Divider key={index} block={block} />;
    default:
      return (
        <p key={index} className="text-sm text-subtle italic">
          This item can’t be displayed. Please update the app.
        </p>
      );
  }
};

const blockKey = (block: StatementBlock, index: number): string => {
  switch (block.type) {
    case BLOCK_TYPE.summary:
      return `summary:${block.hero?.label ?? ""}:${index}`;
    case BLOCK_TYPE.section:
      return `section:${block.heading ?? ""}:${index}`;
    case BLOCK_TYPE.keyValue:
      return `kv:${block.heading ?? ""}:${index}`;
    case BLOCK_TYPE.totals:
      return `totals:${block.label ?? ""}:${index}`;
    case BLOCK_TYPE.divider:
      return `divider:${block.label ?? ""}:${index}`;
    default:
      return `${block.type}:${index}`;
  }
};

export const BlockList = ({ blocks }: { blocks: StatementBlock[] }) => (
  <div className={cn(COLUMN, "divide-y divide-line")}>
    {blocks.map((block, index) => (
      <div key={blockKey(block, index)} className="py-5 first:pt-4 last:pb-8">
        {renderBlock(block, index)}
      </div>
    ))}
  </div>
);
